import React from 'react';
import Topbar from '../components/Topbar';
import { useApp } from '../context/AppContext';
import { ArrowDownRight, ArrowUpRight } from 'lucide-react';

const Wallet = ({ onDeposit }) => {
  const { wallet, txns } = useApp();

  return (
    <div>
      <Topbar count={txns.length} title="WALLET" subtitleUnit="Transactions" onDeposit={onDeposit} />
      <div className="px-8 py-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          {['usdt', 'inr'].map((cur) => (
            <div key={cur} className="border border-[#151515] rounded-md p-5 bg-[#0a0a0a] font-mono relative overflow-hidden">
              <div className="text-[10px] tracking-[0.25em] text-[#5a5a5a]">BALANCE · {cur.toUpperCase()}</div>
              <div className="mt-3 text-3xl text-[#e6e6e6]">
                {cur === 'usdt' ? '$' : '₹'}{Number(wallet[cur] || 0).toFixed(2)}
              </div>
              <button
                onClick={onDeposit}
                className="mt-4 text-[11px] tracking-[0.25em] border border-[#22c55e] text-[#22c55e] px-3 py-1.5 rounded-md hover:bg-[#0f1a12] transition-colors"
              >+ DEPOSIT {cur.toUpperCase()}</button>
              <div className="absolute -right-6 -bottom-6 w-32 h-32 rounded-full bg-[#22c55e]/[0.05] blur-2xl" />
            </div>
          ))}
        </div>

        <div className="border border-[#151515] rounded-md overflow-hidden font-mono">
          <div className="grid grid-cols-[150px_1fr_1fr_1fr_1fr] px-4 py-3 text-[10px] tracking-[0.25em] text-[#5a5a5a] border-b border-[#151515] bg-[#080808]">
            <div>TXN ID</div>
            <div>TYPE</div>
            <div>AMOUNT</div>
            <div>DATE</div>
            <div className="text-right">STATUS</div>
          </div>
          {txns.length === 0 ? (
            <div className="px-4 py-8 text-center text-[12px] text-[#5a5a5a]">No transactions yet.</div>
          ) : txns.map((t) => (
            <div key={t.id} className="grid grid-cols-[150px_1fr_1fr_1fr_1fr] px-4 py-3 text-[12px] border-b border-[#0f0f0f] last:border-0 items-center hover:bg-[#0d0d0d]">
              <div className="text-[#22c55e]">{t.id}</div>
              <div className="flex items-center gap-2">
                {t.amount >= 0
                  ? <ArrowDownRight size={13} className="text-[#22c55e]" />
                  : <ArrowUpRight size={13} className="text-[#f59e0b]" />}
                <span className="text-[#e6e6e6]">{t.type}</span>
              </div>
              <div className={t.amount >= 0 ? 'text-[#22c55e]' : 'text-[#e6e6e6]'}>
                {t.amount >= 0 ? '+' : '-'}{t.currency === 'USDT' ? '$' : '₹'}{Math.abs(t.amount).toFixed(2)}
              </div>
              <div className="text-[#8a8a8a]">{t.created_at}</div>
              <div className="text-right tracking-[0.2em] text-[#8a8a8a]">{t.status}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Wallet;
